export default [
  {
    title: "Customer Management",
    customIcon: "CustomerSVG",
    children: [
      {
        title: "Customer Data",
        route: "custom-customer-list",
        path: "/custom-customer/list",
      },
    ],
  },
];
